import { useDispatch, useSelector } from "react-redux";

import { InformationIcon } from "@/assets/icons";
import { Switch } from "@/components/ui/switch";
import { MESSAGE } from "@/constants/message";
import { RootState } from "@/store";
import { setDasimetry } from "@/store/slice/spatialSlice";

const DasimetrySection = () => {
  const dispatch = useDispatch();
  const {
    spatialConfig: { dasimetry }
  } = useSelector((state: RootState) => state.spatial);
  return (
    <div className="flex flex-col gap-3 px-4 mt-4 mb-2">
      <div className="flex flex-col gap-1">
        <span className="font-sans font-semibold text-txtHeading text-sm">
          {MESSAGE.DASIMETRY.ANALYSIS_CONFIGURATION_TITLE}
        </span>
        <span className="text-[10px] text-txtBody">
          {MESSAGE.DASIMETRY.ANALYSIS_CONFIGURATION_DESCRIPTION}
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <div className="flex justify-between items-center">
          <span className="font-sans text-sm font-semibold text-txtBody">
            {MESSAGE.DASIMETRY.PROPORTION_TITLE}
          </span>
          <Switch
            checked={dasimetry}
            onCheckedChange={(checked) => dispatch(setDasimetry(checked))}
          />
        </div>
        <span className="text-[10px] text-txtBody">
          {MESSAGE.DASIMETRY.PROPORTION_DESCRIPTION}
        </span>
      </div>
      <div className="flex items-center bg-[#FAFAFA] border border-neutral-200 rounded-xl px-3 py-2">
        <span className="text-[10px] text-txtBody">
          <InformationIcon className="w-4 h-4 mr-1 inline fill-txtBody" />
          {MESSAGE.DASIMETRY.APPLIES_TO_ADMIN_AREA_ONLY}
        </span>
      </div>
    </div>
  );
};

export default DasimetrySection;
